"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = __importDefault(require("@emotion/cache"));
var react_1 = __importDefault(require("react"));
var react_frame_component_1 = __importStar(require("react-frame-component"));
// @ts-ignore
var styled_components_1 = require("styled-components");
var react_2 = require("@emotion/react");
var styles_1 = require("../../styles");
var List_1 = __importDefault(require("../Templates/List/List"));
var InfopageTemplate_1 = __importDefault(require("../Templates/Infopage/InfopageTemplate"));
var previewFrame_1 = require("../../types/previewFrame");
var previewIframeStyle = {
    margin: 'auto',
    position: 'relative',
    border: '10px solid black',
    borderRadius: '4px',
    boxShadow: '0 0 1px 2px rgba(0,0,0,0.5), 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)'
};
var getHtmlHead = function (template, orientation, infopageContent) { return react_1.default.createElement("style", null, (0, styles_1.getStyles)(template, orientation, infopageContent)); };
/**
 * Preview frame for Infopage/List with template.
 */
var PreviewFrame = function (_a) {
    var content = _a.content, id = _a.id, width = _a.width, height = _a.height;
    var infopageProps = content;
    var infopageContent = infopageProps === null || infopageProps === void 0 ? void 0 : infopageProps.infopageContent;
    return (react_1.default.createElement(react_frame_component_1.default, { id: id, head: getHtmlHead(content.template, content.orientation, infopageContent), style: __assign(__assign({}, previewIframeStyle), { width: width, height: height }) },
        react_1.default.createElement(react_frame_component_1.FrameContextConsumer, null, function (_a) {
            var document = _a.document;
            var cache = (0, cache_1.default)({
                key: 'css',
                container: document === null || document === void 0 ? void 0 : document.head,
                prepend: true
            });
            return (react_1.default.createElement(styled_components_1.StyleSheetManager, { target: document === null || document === void 0 ? void 0 : document.head },
                react_1.default.createElement(react_2.CacheProvider, { value: cache },
                    react_1.default.createElement(react_1.default.Fragment, null, (0, previewFrame_1.isListPreviewFrame)(content) ? (react_1.default.createElement(List_1.default, __assign({}, content))) : (react_1.default.createElement(InfopageTemplate_1.default, __assign({}, content)))))));
        })));
};
exports.default = PreviewFrame;
//# sourceMappingURL=PreviewFrame.js.map